<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-layout row wrap>
          <p class="headline">Director's Corner</p>
          <v-flex >
            <p class="subheading">• Master in Information Technology(MIT) - Mindanao University of Science and Technology (MUST), Cagayan de Oro City, Philippines, April 3, 2013.</p>
            <p class="subheading">• Bachelor of Science in Computer Science – STI Zamboanga – June, 2005.</p>
            <p class="subheading">• Professional Course in Education – Western Mindanao State University, Zamboanga City, Philippines</p>
            <p class="subheading">• Master in Public Administration -Western Mindanao State University, Philippines, March, 1997.</p>
            <p class="subheading">• Bachelor of Science in Commerce, Accounting – Zamboanga A.E. Colleges, Philippines.</p>
            <p class="subheading">• Doctor of Philosophy-Technology Management Program (PhD-TM), on dissertation writing, Zamboanga City State Polytechnic College, Philippines.</p>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  
}
</script>



// WEBPACK FOOTER //
// src/components/HomePage/Director.vue